// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"4326786a","977":"9fce75cb"}[chunkId] + ".chunk.js";
};